import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { BaseIdentityAPI, OktaService } from 'sustainment-component';

@Injectable()
export class PrismaticApi extends BaseIdentityAPI {
  protected urlBase: string;
  private _oktaService: OktaService;

  public constructor(http: HttpClient, oktaService: OktaService) {
    super(http, oktaService, environment);
    this.urlBase = environment.identityApiBaseUrl + 'account/';
  }

  public getPrismaticToken(sustainmentId: string): Observable<{ token: string }> {
    return this.oktaAuthHeader().pipe(
      mergeMap((headers) =>
        this._http.get<{ token: string }>(
          this.urlBase + `${sustainmentId}/prismatic-token`,
          { headers }
        )
      )
    );
  }
}
